import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import ErrorAlert from '../../../../components/ErrorAlert/ErrorAlert'
import GitLabProviderLogo from '../../../../components/GitLabProviderLogo'
import BasicInput from '../../../../components/InputField/BasicInput'
import PrimaryButton from '../../../../components/PrimaryButton'
import useForm from '../../../../hooks/useForm'
import {Dialog} from '../../../../ui/Dialog/Dialog'
import {DialogContent} from '../../../../ui/Dialog/DialogContent'
import {DialogTitle} from '../../../../ui/Dialog/DialogTitle'
import linkify from '../../../../utils/linkify'
import makeAppURL from '../../../../utils/makeAppURL'
import Legitity from '../../../../validation/Legitity'
import CopyShortLink from '../../../meeting/components/CopyShortLink/CopyShortLink'













const UpsertGitLabProviderDialog = (props) => {
  const {isOpen, onClose, defaults, onUpsert, error} = props

  const redirectUri = makeAppURL(window.location.origin, 'auth/gitlab')
  const {fields, onChange, validateField} = useForm({
    serverBaseUrl: {
      getDefault: () => defaults.serverBaseUrl,
      validate: (rawInput) => {
        return new Legitity(rawInput).test((maybeUrl) => {
          if (!maybeUrl) return 'Please enter a server base URL'
          const links = linkify.match(maybeUrl)
          return !links ? 'Not looking too linky' : ''
        })
      }
    },
    clientId: {
      getDefault: () => defaults.clientId,
      validate: (clientId) => {
        return new Legitity(clientId).required('Please enter a client ID')
      }
    },
    clientSecret: {
      getDefault: () => defaults.clientSecret,
      validate: (clientSecret) => {
        return new Legitity(clientSecret).required('Please enter a client secret')
      }
    }
  })

  const onSubmit = () => {
    const validation = validateField()
    if (Object.values(validation).some(({error}) => error)) return
    onUpsert(fields.serverBaseUrl.value, fields.clientId.value, fields.clientSecret.value)
    _optionalChain([onClose, 'optionalCall', _ => _()])
  }

  return (
    _jsx(Dialog, { isOpen: isOpen, onClose: onClose, children: 
      _jsxs(DialogContent, { children: [
        _jsxs(DialogTitle, { className: "flex items-center" , children: [
          _jsx(GitLabProviderLogo, {} )
          , _jsx('div', { className: "ml-2", children: "Add GitLab Server"  })
        ]})
        , _jsxs('form', {
          onSubmit: (e) => {
            e.preventDefault()
            onSubmit()
          },
 children: [
          _jsxs('div', { className: "pt-6 pb-2" , children: ["In the "
              , _jsx('b', { children: "Admin Area" }), ", " , _jsx('b', { children: "Applications"}), " add a "   , _jsx('b', { children: "New application" }), " with the following settings"

          ]})
          , _jsxs('div', { className: "flex items-center p-2"  , children: [
            _jsx('div', { className: "w-36", children: "Name"})
            , _jsx('div', { children: "Parabol"})
          ]})
          , _jsxs('div', { className: "flex items-center px-2"  , children: [
            _jsx('div', { className: "w-36", children: "Redirect URI" })
            , _jsx(CopyShortLink, {
              className: "h-10 rounded-sm border border-dashed px-2"    ,
              icon: "link",
              url: redirectUri,
              title: "Redirect URL" ,
              tooltip: "Copied Redirect URL"  ,}
            )
          ]})
          , _jsxs('div', { className: "flex items-center p-2"  , children: [
            _jsx('div', { className: "w-36", children: "Trusted"})
            , _jsx('div', { children: "Yes or No"  })
          ]})
          , _jsxs('div', { className: "flex items-center p-2"  , children: [
            _jsx('div', { className: "w-36", children: "Confidential"})
            , _jsx('div', { children: "Yes"})
          ]})
          , _jsxs('div', { className: "flex items-center p-2"  , children: [
            _jsx('div', { className: "w-36", children: "Scopes"})
            , _jsxs('div', { children: [
              _jsx('b', { children: "api"}), " (Access the authenticated user's API)"
            ]})
          ]})
          , _jsxs('div', { className: "pt-6 pb-2" , children: ["Press "
             , _jsx('b', { children: "Save application" }), " and enter the "    , _jsx('b', { children: "Application ID" }), " and "  , _jsx('b', { children: "Secret"}), ' ', "below"

          ]})
          , _jsxs('div', { className: "flex items-center p-2"  , children: [
            _jsx('div', { className: "w-36 shrink-0" , children: "Server base URL"  })
            , _jsx('div', { className: "flex w-full flex-col"  , children: 
              _jsx(BasicInput, {
                ...fields.serverBaseUrl,
                onChange: onChange,
                name: "serverBaseUrl",
                placeholder: "https://gitlab.example.com",}
              )
            })
          ]})
          , _jsxs('div', { className: "flex items-center p-2"  , children: [
            _jsx('div', { className: "w-36 shrink-0" , children: "Application ID" })
            , _jsx('div', { className: "flex w-full flex-col"  , children: 
              _jsx(BasicInput, {
                ...fields.clientId,
                onChange: onChange,
                name: "clientId",
                placeholder: "Enter your Application ID here..."    ,}
              )
            })
          ]})
          , _jsxs('div', { className: "flex items-center p-2"  , children: [
            _jsx('div', { className: "w-36 shrink-0" , children: "Secret"})
            , _jsx('div', { className: "flex w-full flex-col"  , children: 
              _jsx(BasicInput, {
                ...fields.clientSecret,
                onChange: onChange,
                name: "clientSecret",
                placeholder: "Enter your Secret here..."   ,}
              )
            })
          ]})
          , error && _jsx(ErrorAlert, { message: error.message,} )
          , _jsx('div', { className: "flex justify-end pt-6"  , children: 
            _jsx(PrimaryButton, { type: "submit", onClick: onSubmit, children: "Save"

            })
          })
        ]})
      ]})
    })
  )
}

export default UpsertGitLabProviderDialog
